/*
  EssentialsX product page — keeps the shipping offer line (snippets/shipping-offer-pdp.liquid)
  in step with the cart. The line is rendered on the server from `cart`, so it is right when the
  page loads; this script re-reads /cart.js after a cart change (add from this page, drawer
  quantity change or removal) and after a back/forward restore, and shows the matching state.

  Pieces = floor(cart weight / weight per piece), the same count the cart ladder uses
  (snippets/shipping-ladder.liquid). Loaded only on product pages from layout/theme.liquid.
*/
import { StandardEvents } from '@shopify/events';

function lines() {
  return document.querySelectorAll('.ship-pdp[data-unit]');
}

function show(line, pieces) {
  var free = Number(line.dataset.free);
  var last = Number(line.dataset.last);
  var rung1 = Number(line.dataset.rung1);
  var state = pieces >= free ? 'free' : pieces >= last ? 'last' : pieces >= rung1 ? 'mid' : 'start';
  line.querySelectorAll('[data-state]').forEach(function (el) {
    el.hidden = el.dataset.state !== state;
  });
}

function refresh() {
  if (lines().length === 0) return;
  fetch('/cart.js', { headers: { Accept: 'application/json' } })
    .then(function (response) {
      return response.json();
    })
    .then(function (cart) {
      lines().forEach(function (line) {
        var unit = Number(line.dataset.unit);
        if (unit > 0) show(line, Math.floor(cart.total_weight / unit));
      });
    })
    .catch(function () {});
}

document.addEventListener(StandardEvents.cartLinesUpdate, function (event) {
  if (event.promise) {
    event.promise.then(refresh).catch(function () {});
  } else {
    refresh();
  }
});

window.addEventListener('pageshow', function (event) {
  if (event.persisted) refresh();
});
